import React from 'react';
import { FlameIcon } from 'lucide-react';
type Props = {
  tone?: 'dark' | 'light';
};
export function ScarcityBar({
  tone = 'dark'
}: Props) {
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl p-4 sm:p-5 ${isDark ? 'bg-white/10 ring-1 ring-white/20' : 'bg-white ring-1 ring-ink/10'}`} data-id="element-50" data-mp="2l563efeuf1ts">
      <div className="flex items-center justify-between gap-3" data-id="element-51" data-mp="2q269urflu6lf">
        <span className={`inline-flex items-center gap-1.5 text-[12px] font-extrabold uppercase tracking-[0.12em] sm:text-[13px] ${isDark ? 'text-white' : 'text-plum-deep'}`} data-id="element-52" data-mp="2b5p0u6uw1421">
          <FlameIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-53" data-mp="227murcwarl7w" />
          Restano solo 9 posti
        </span>
        <span className="text-[12px] font-extrabold text-gold sm:text-[13px]" data-id="element-54" data-mp="27798rojy95hr">94%</span>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/20' : 'bg-ink/10'}`} role="progressbar" aria-valuenow={94} aria-valuemin={0} aria-valuemax={100} aria-label="Posti richiesti al prezzo promozionale" data-id="element-55" data-mp="cm6uimig9bd">
        <div className="h-full rounded-full bg-gold" style={{
        width: '94%'
      }} data-id="element-56" data-mp="3dcoixlyqfsai" />
      </div>

      <p className={`mt-3 text-[12.5px] leading-relaxed sm:text-sm ${isDark ? 'text-white/75' : 'text-ink/65'}`} data-id="element-57" data-mp="38d38aea79vhy">
        Restano <strong className={isDark ? 'text-white' : 'text-plum-deep'} data-id="element-58" data-mp="2kq3fvo8w9rr4">9 posti</strong> al
        prezzo promozionale di 19 €. Quando saranno esauriti, il prezzo tornerà a 297 €.
      </p>
    </div>;
}